var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.iSEdited
        ? _vm.$t("label_essweb_leaveType_form_editTitle")
        : _vm.$t("label_essweb_leaveType_form_viewTitle"),
      widthClass: "max-1000",
      pad: "0",
      delBtn: "",
      initData: _vm.LeaveTypeData,
      checkData: [
        "leave_type_name",
        "color_code",
        "sequence",
        "unit",
        "remarks",
        "leave_type_abbr",
        "leave_type_property_group_uuid",
        "leave_type_description",
      ],
      editBtn: !_vm.iSEdited,
    },
    on: {
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
      edit: function ($event) {
        _vm.iSEdited = true
      },
      delete: function ($event) {
        _vm
          .$confirmDo(_vm.$t("label_essweb_leaveType_list_title"))
          .then(function (res) {
            res ? _vm.toDelete() : null
          })
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Taber", {
              attrs: { curTab: _vm.curTab, items: _vm.taber },
              on: {
                change: function (tab) {
                  return (_vm.curTab = tab)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      maxlength: "100",
                                      filled: _vm.iSEdited,
                                      readonly: !_vm.iSEdited,
                                      bindData:
                                        _vm.LeaveTypeData.leave_type_name,
                                      label: _vm.$t(
                                        "label_essweb_leaveType_form_leaveTypeNameLabel"
                                      ),
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.LeaveTypeData.leave_type_name =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      maxlength: "20",
                                      readonly: !_vm.iSEdited,
                                      filled: _vm.iSEdited,
                                      bindData:
                                        _vm.LeaveTypeData.leave_type_abbr,
                                      label: _vm.$t(
                                        "label_essweb_leaveType_form_leaveTypeAbbrLabel"
                                      ),
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.LeaveTypeData.leave_type_abbr =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      readonly: !_vm.iSEdited,
                                      filled: _vm.iSEdited,
                                      isNotRequire: "",
                                      type: "number",
                                      maxlength: "255",
                                      rules: _vm.$GetRules(
                                        ["_Number_negative", "_Length_Rules"],
                                        [null, 255]
                                      ),
                                      label: _vm.$t(
                                        "label_essweb_leaveType_form_sequenceLabel"
                                      ),
                                    },
                                    model: {
                                      value: _vm.LeaveTypeData.sequence,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.LeaveTypeData,
                                          "sequence",
                                          $$v
                                        )
                                      },
                                      expression: "LeaveTypeData.sequence",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "mrc_text_require text--secondary",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_leaveType_form_unitLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.Units,
                                      readonly: !_vm.iSEdited,
                                      filled: _vm.iSEdited,
                                      "item-value": "value_field",
                                      "item-text": "view_fields",
                                      "single-line": "",
                                      "menu-props": {
                                        offsetY: true,
                                        transition: "slide-y-transition",
                                        rounded: true,
                                        contentClass: "elevation-4",
                                      },
                                      "append-icon": _vm.iSEdited
                                        ? "arrow_drop_down"
                                        : "",
                                      rules: _vm.$GetRules("_Require_Rules", [
                                        null,
                                      ]),
                                      dense: "",
                                      label: _vm.$t(
                                        "label_essweb_leaveType_form_unitLabel"
                                      ),
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "no-data",
                                        fn: function () {
                                          return [_c("noContent")]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "selection",
                                        fn: function (ref) {
                                          var item = ref.item
                                          var index = ref.index
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    item.view_fields
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item",
                                        fn: function (ref) {
                                          var item = ref.item
                                          var index = ref.index
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    item.view_fields
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                    model: {
                                      value: _vm.LeaveTypeData.unit,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.LeaveTypeData, "unit", $$v)
                                      },
                                      expression: "LeaveTypeData.unit",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      label: _vm.$t(
                                        "label_essweb_leaveTransactionPropertyGroup_form_codeLabel"
                                      ),
                                      filled: _vm.iSEdited,
                                      readonly: !_vm.iSEdited,
                                      rules: _vm.$GetRules("_Require_Rules", [
                                        null,
                                      ]),
                                      maxlength: "50",
                                    },
                                    model: {
                                      value: _vm.LeaveTypeData.leave_type_code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.LeaveTypeData,
                                          "leave_type_code",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "LeaveTypeData.leave_type_code",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      filled: _vm.iSEdited,
                                      readonly: !_vm.iSEdited,
                                      bindData:
                                        _vm.LeaveTypeData
                                          .leave_type_description,
                                      label: _vm.$t(
                                        "label_essweb_leaveType_form_descriptionLabel"
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.LeaveTypeData.leave_type_description =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "mrc_text_require text--secondary",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_leaveType_form_leaveTypePropertyGroupLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.propertyGroup,
                                      "item-value": "uuid",
                                      "item-text":
                                        "leave_type_property_group_name",
                                      "append-icon": _vm.iSEdited
                                        ? "arrow_drop_down"
                                        : "",
                                      filled: _vm.iSEdited,
                                      "single-line": "",
                                      readonly: !_vm.iSEdited,
                                      rules: _vm.$GetRules("_Require_Rules", [
                                        null,
                                      ]),
                                      dense: "",
                                      label: _vm.$t(
                                        "label_essweb_leaveType_form_leaveTypePropertyGroupLabel"
                                      ),
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "no-data",
                                        fn: function () {
                                          return [_c("noContent")]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value:
                                        _vm.LeaveTypeData
                                          .leave_type_property_group_uuid,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.LeaveTypeData,
                                          "leave_type_property_group_uuid",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "LeaveTypeData.leave_type_property_group_uuid",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "mrc_text_require text--secondary",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_leaveType_form_tagColorLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("SelectColor", {
                                    attrs: {
                                      items: _vm.Colors,
                                      readonly: !_vm.iSEdited,
                                      filled: _vm.iSEdited,
                                      appendIcon: _vm.iSEdited
                                        ? "arrow_drop_down"
                                        : "",
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    model: {
                                      value: _vm.LeaveTypeData.color_code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.LeaveTypeData,
                                          "color_code",
                                          $$v
                                        )
                                      },
                                      expression: "LeaveTypeData.color_code",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    { staticClass: "text--secondary" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_leaveType_form_remarkLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-textarea", {
                                    attrs: {
                                      rows: "5",
                                      "no-resize": "",
                                      maxlength: "500",
                                      filled: _vm.iSEdited,
                                      "single-line": "",
                                      readonly: !_vm.iSEdited,
                                      dense: "",
                                      counter: "500",
                                      name: "input-7-4",
                                    },
                                    model: {
                                      value: _vm.LeaveTypeData.remarks,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.LeaveTypeData,
                                          "remarks",
                                          $$v
                                        )
                                      },
                                      expression: "LeaveTypeData.remarks",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _c(
                        "v-container",
                        {
                          staticClass: "mrc-grey rounded-lg",
                          attrs: { fluid: "" },
                        },
                        _vm._l(_vm.leave_type_notice, function (item, index) {
                          return _c(
                            "v-sheet",
                            {
                              key: index,
                              staticClass: "rounded-lg pa-0 drag mt-2 mb-2",
                            },
                            [
                              _c("v-hover", {
                                attrs: { "open-delay": "100" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var hover = ref.hover
                                        return [
                                          _c(
                                            "v-card",
                                            {
                                              staticClass:
                                                "pa-2 d-flex rounded-lg align-center",
                                              attrs: {
                                                elevation: hover ? 4 : 2,
                                              },
                                            },
                                            [
                                              _c("svg-icon", {
                                                staticStyle: {
                                                  "min-width": "36px",
                                                },
                                                attrs: {
                                                  size: "36",
                                                  fill: "black",
                                                  iconClass: "arrow01",
                                                },
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "text-body-2" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$getCommonLangValue(
                                                          item[
                                                            "leave_type_notice_point_" +
                                                              item.number
                                                          ]
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c("v-spacer"),
                                              hover && _vm.iSEdited
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        icon: "",
                                                        small: "",
                                                        disabled: !_vm.iSEdited,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.toEditNotice(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "material-icons-round",
                                                        },
                                                        [_vm._v("edit")]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              hover && _vm.iSEdited
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        icon: "",
                                                        disabled: !_vm.iSEdited,
                                                        small: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.onDeleteNotice(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "material-icons-round",
                                                        },
                                                        [_vm._v("delete")]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-3",
                  fn: function () {
                    return [
                      _c("Tabler", {
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.leave_transaction_type,
                          border: "",
                          avPerPage: 50,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item.name",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "div",
                                  { staticClass: "table-title text--primary" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$getCommonLangValue(
                                            item.leave_transaction_type_name
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.code",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "div",
                                  { staticClass: "table-title text--primary" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          item.leave_transaction_type_common_code
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.type",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "div",
                                  { staticClass: "table-title text--primary" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$getCommonLangValue(
                                            item.leave_type_name
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.action",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm.iSEdited
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          icon: "",
                                          small: "",
                                          disabled: !_vm.iSEdited,
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.curTranTypeUuid = item.uuid
                                            _vm.showEditTranType = true
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "material-icons-round",
                                          },
                                          [_vm._v("edit")]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.iSEdited
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          icon: "",
                                          small: "",
                                          disabled: !_vm.iSEdited,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toDeleteTransactionType(
                                              item.uuid
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "material-icons-round",
                                          },
                                          [_vm._v("delete")]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "footer",
                            fn: function () {
                              return [
                                _c(
                                  "v-container",
                                  { staticClass: "pa-0", attrs: { fluid: "" } },
                                  [
                                    _vm.iSEdited ? _c("v-divider") : _vm._e(),
                                    _vm.iSEdited
                                      ? _c(
                                          "v-btn",
                                          {
                                            staticClass: "my-2 text-capitalize",
                                            attrs: {
                                              text: "",
                                              small: "",
                                              color: "primary",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.showNewTranType = true
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "label_essweb_leaveType_form_dialog_addLeaveTransactionTypeBtnLabel"
                                                  )
                                                ) +
                                                " "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "material-icons-round",
                                              },
                                              [_vm._v("add")]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-4",
                  fn: function () {
                    return [
                      _c(
                        "v-card",
                        { staticClass: "pa-0", attrs: { elevation: 0 } },
                        [
                          _c(
                            "v-card-text",
                            { staticClass: "pa-0" },
                            [
                              _c("Tabler", {
                                attrs: {
                                  headers: _vm.headers2,
                                  showNoContent: false,
                                  items: _vm.desserts2,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item.holiday_type_name",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$getCommonLangValue(
                                              item.holiday_type_name
                                            )
                                          )
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.holiday_type_code",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _vm._v(_vm._s(item.holiday_type_code)),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-card-actions",
                            { staticClass: "pb-0 pl-0" },
                            [
                              _vm.iSEdited
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "text-capitalize mb-3",
                                      attrs: {
                                        text: "",
                                        color: "primary",
                                        small: "",
                                      },
                                      on: { click: _vm.toEditMapping },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "label_essweb_leaveType_form_editHolidayTypeBtnLabel"
                                            )
                                          ) +
                                          " "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "material-icons-round" },
                                        [_vm._v("add")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _vm.iSEdited && _vm.curTab == "tab-1"
              ? _c("CardActions", {
                  attrs: { saveBtn: _vm.curTab == "tab-1" },
                  on: {
                    save: _vm.toSave,
                    cancel: function ($event) {
                      return _vm.$toBack(_vm.isChanged)
                    },
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("editNotice", {
              attrs: {
                show: _vm.showEditNotice,
                PropertyData: _vm.NoticePropertyData,
              },
              on: {
                close: function ($event) {
                  _vm.showEditNotice = false
                  _vm.NoticePropertyData = null
                },
                onEdit: _vm.onEditNotice,
              },
            }),
            _c("newTransactionType", {
              attrs: { show: _vm.showNewTranType },
              on: {
                close: function ($event) {
                  _vm.showNewTranType = false
                },
                onNew: _vm.onNewTranType,
              },
            }),
            _c("editTransactionType", {
              attrs: {
                show: _vm.showEditTranType,
                curUuid: _vm.curTranTypeUuid,
              },
              on: {
                close: function ($event) {
                  _vm.showEditTranType = false
                  _vm.curTranTypeUuid = null
                },
                onEdit: _vm.onEditTranType,
              },
            }),
            _c("editHolidayType", {
              attrs: { show: _vm.mapToDiag, PorpertyData: _vm.curPorperty },
              on: {
                editPorperty: _vm.onEditProperty,
                close: function ($event) {
                  _vm.mapToDiag = false
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }